import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import EnvironmentManager from 'Utils/environmentManager';
import {
  CANCEL_TJK_COUPON_FAILURE,
  CANCEL_TJK_COUPON_REQUEST,
  CANCEL_TJK_COUPON_SUCCESS,
  PLAY_COUPON_FAILURE,
  PLAY_TJK_COUPON_REQUEST,
  PLAY_TJK_COUPON_SUCCESS,
  REMOVE_ALL_HORSES,
  REMOVE_HORSE,
  RESET_HR_BETSLIP,
  SELECT_ALL_HORSES,
  SELECT_HORSE,
  SET_HR_BETSLIP_ALL_VARIATION,
  SET_HR_BETSLIP_COUPON_COUNT,
  SET_HR_BETSLIP_FROM_COUPON,
  SET_HR_BETSLIP_FROM_LOCAL_STORAGE,
  SET_HR_BETSLIP_MULTIPLIER,
  SET_HR_FIXED_ODD_MULTIPLIER,
  TOGGLE_HR_BETSLIP,
  VERIFY_TJK_COUPON_FAILURE,
  VERIFY_TJK_COUPON_REQUEST,
  VERIFY_TJK_COUPON_SUCCESS,
  SET_ORDERED_LEGS,
  SET_FROM_AUTHOR_DATA,
  CLEAR_FROM_AUTHOR_DATA,
  ADD_COMBINED_HORSE,
  REMOVE_COMBINED_HORSE,
  REPLACE_COMBINED_HORSE,
  SET_BETSLIP_TOAST,
  ADD_PROPOSITION,
  REMOVE_PROPOSITION,
  REPLACE_PROPOSITION,
  SET_SYSTEM,
  TOGGLE_SYSTEM_MODAL
} from 'Store/constants';
import { closeModal, openModal } from 'Store/actions';
import { catchTJKError } from 'Utils/catchTJKError';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import { isBetSlipEmpty } from 'Utils/horseRacingBetslipValidation';
import History from 'Store/history';
import { updateUserBalance } from 'Store/actions/authActions';
import { isTjkPlayDisable, TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import { findInHippodromeByName } from 'Utils/horseRacesNameMapper';
import { shouldRedirectToLowBalanceFastDeposit } from 'Utils/lowBalanceFastDeposit';
import qs from 'query-string';
import { resetCouponsPagination } from 'Store/actions/horseRacing/couponActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { isOddLocked } from 'Utils/decimalFormatter';

export const setHRBetslipFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('horseRacingBetslip', data => {
    dispatch({
      type: SET_HR_BETSLIP_FROM_LOCAL_STORAGE,
      payload: data ? data : {}
    });
  });
};

export const addHorsetoBetSlip = (leg, horse, selectedInfos) => async (dispatch, getState) => {
  const programType = getState().horseRacing.allHippodromes.programType;
  if (isTjkPlayDisable()) {
    return null;
  }
  if (programType === PROGRAM_TYPES.FIXED && isOddLocked(horse?.propositionInfo?.status)) {
    return null;
  }
  try {
    const isBultenChanged = getState().horseRacing.betSlip.isBultenChanged;
    const legs = getState().horseRacing.betSlip?.legs;

    if (isBultenChanged && !isBetSlipEmpty(legs)) {
      dispatch(openModal('tjkCouponInformationModal', {
        successCallback: () => dispatch({
          payload: { leg: leg, horse: horse, selectedInfos },
          type: SELECT_HORSE,
        })
      }));
      return;
    }

    dispatch({
      payload: { leg: leg, horse: horse, selectedInfos },
      type: SELECT_HORSE,
    });
  } catch (e) {
    //console.log('error', e);
  }
};

const handleSystemRemoval = () => async (dispatch, getState) => {
  const betSlip = getState().horseRacing.betSlip;
  const { combinedHorses, footerData } = betSlip;
  const { system } = footerData;
  const betCount = (combinedHorses?.length || 0) - 1;
  let data;
  if (system?.length === 1 && system[0] === betCount + 1) {
    data = [betCount];
  } else {
    data = system.filter(item => item <= betCount);
  }
  if (betCount === 0) {
    data = [];
  }
  dispatch(setHRBetslipSystem(data));
};

export const addHorseToCombinedBetSlip = (horse, hippodrome, bet, leg) => async (dispatch, getState) => {
  try {
    const maxHorseCount = Number( EnvironmentManager.getMessageText({ key: 'v1.general.parlay_odd_limit_count' })) || 7;
    const betSlip = getState().horseRacing.betSlip;
    const { combinedHorses, footerData } = betSlip;
    const { system } = footerData;
    let data = system;

    if (combinedHorses?.some(item => item?.horse?.propositionInfo?.propositionId === horse?.propositionInfo?.propositionId)) {
      dispatch(handleSystemRemoval());
      dispatch({
        type: REMOVE_COMBINED_HORSE,
        payload: horse
      });
    } else if (combinedHorses?.some(h => h?.hippodrome?.cardId === hippodrome?.cardId && h?.leg?.legNo === leg?.legNo && h?.bet?.id === bet.id)) {
      dispatch({
        type: REPLACE_COMBINED_HORSE,
        payload: { horse, hippodrome, bet, leg }
      });

    } else if (combinedHorses?.some(h => h?.hippodrome?.cardId === hippodrome?.cardId && h?.leg?.legNo === leg?.legNo)) {
      dispatch( setBetslipToast({
        show: true,
        icon: 'svgInfoWhite',
        content: '<h6>Her koşu için yalnızca bir bahis tercihi eklenebilir.</h6>'
      }));
    } else if (combinedHorses?.length > 0 && !bet?.isParlayable && !combinedHorses?.some(h=> h?.bet?.isParlayable === false)) {
      dispatch( setBetslipToast({
        show: true,
        icon: 'svgInfoWhite',
        content: `<h6>Betslip’inde Kombine Bahis varken ${bet?.description} Bahis ekleyemezsin.</h6>`
      }));
    } else if (combinedHorses?.some(h=> h?.bet?.isParlayable === false)) {
      dispatch( setBetslipToast({
        show: true,
        icon: 'svgInfoWhite',
        content: `<h6>Betslip’inde ${combinedHorses?.find(h=> h?.bet?.isParlayable === false)?.bet?.description} Bahis varken başka bir bahis türü oynayamazsın.</h6>`
      }));
    }  else {
      if (combinedHorses?.length === maxHorseCount) {
        dispatch( setBetslipToast({
          show: true,
          icon: 'svgInfoWhite',
          content: `<h6>En fazla ${maxHorseCount} at Ekleyebilirsin</h6><p>Eklemek için bahsindeki atlardan birini silmen lazım</p>`
        }));
        return;
      }
      if (combinedHorses?.length === 0 && system?.length === 0) {
        data = [1];
      }
      if (system?.length === 1 && system[0] === combinedHorses?.length) {
        data = [combinedHorses.length + 1];
      }
      dispatch(setHRBetslipSystem(data));
      dispatch({
        payload: { horse, hippodrome, bet, leg },
        type: ADD_COMBINED_HORSE,
      });
    }

  } catch (e) {
    console.log('error', e);
  }
};

export const removeHorseFromCombinedBetSlip = horse => async (dispatch, getState) => {
  try {
    dispatch(handleSystemRemoval());
    dispatch({
      type: REMOVE_COMBINED_HORSE,
      payload: horse
    });
  } catch (e) {
    console.log('e', e);
  }
};

export const addPropositionToBetSlip = (proposition, hippodrome, bet, leg) => async (dispatch, getState) => {
  try {
    const propositions = getState().horseRacing.betSlip.propositions;
    const combinedHorses = getState().horseRacing.betSlip.combinedHorses;

    if (combinedHorses?.length > 0) {
      dispatch( setBetslipToast({
        show: true,
        icon: 'svgInfoWhite',
        content: '<p>Betslip’inde Kombine Bahis varken 2’li Bahis ekleyemezsin.</p>'
      }));
      return;
    }

    if (propositions?.some(h => h?.proposition?.propositionId === proposition.propositionId)) {
      dispatch({
        type: REMOVE_PROPOSITION,
        payload: proposition
      });
    } else if (propositions?.length > 0) {
      dispatch({
        type: REPLACE_PROPOSITION,
        payload: { proposition, hippodrome, bet, leg }
      });
    } else {
      dispatch({
        payload: { proposition, hippodrome, bet, leg },
        type: ADD_PROPOSITION,
      });
    }

  } catch (e) {
    //console.log('error', e);
  }
};

export const removePropositionFromBetSlip = proposition => async (dispatch, getState) => {
  try {
    dispatch({
      type: REMOVE_PROPOSITION,
      payload: proposition
    });
  } catch (e) {
    //console.log('error', e);
  }
};

export const addAllHorsestoBetSlip = (leg, horses, selectedInfos) => async (dispatch, getState) => {
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    const isBultenChanged = getState().horseRacing.betSlip.isBultenChanged;
    const legs = getState().horseRacing.betSlip?.legs;

    if (isBultenChanged && !isBetSlipEmpty(legs)) {
      dispatch(openModal('tjkCouponInformationModal', {
        successCallback: () => dispatch({
          payload: { leg: leg, horses: horses, selectedInfos },
          type: SELECT_ALL_HORSES,
        })
      }));
      return;
    }

    dispatch({
      payload: { leg: leg, horses: horses, selectedInfos },
      type: SELECT_ALL_HORSES,
    });

  } catch (e) {
    //console.log('error', e);
  }
};

export const removeHorseFromBetSlip = (leg, horse) => async dispatch => {
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    dispatch({
      payload: { leg: leg, horse: horse },
      type: REMOVE_HORSE,
    });
  } catch (e) {
    //console.log('error', e);
  }
};

export const removeAllHorsesFromBetSlip = leg => async dispatch => {
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    dispatch({
      payload: { leg: leg },
      type: REMOVE_ALL_HORSES,
    });
  } catch (e) {
    //console.log('error', e);
  }
};

export const resetHRBetSlip = () => dispatch => {
  dispatch({
    type: RESET_HR_BETSLIP
  });
};

export const setHRBetslipMultiplier = data => (dispatch, getState) => {
  const programType = getState().horseRacing.allHippodromes.programType;
  const isFixed = programType === PROGRAM_TYPES.FIXED;
  const type = isFixed ? SET_HR_FIXED_ODD_MULTIPLIER : SET_HR_BETSLIP_MULTIPLIER;
  dispatch({
    type,
    payload: data
  });
};

export const setHRBetslipCouponCount = data => dispatch => {
  dispatch({
    type: SET_HR_BETSLIP_COUPON_COUNT,
    payload: data
  });
};

export const setHRBetslipAllVariation = data => dispatch => {
  dispatch({
    type: SET_HR_BETSLIP_ALL_VARIATION,
    payload: data
  });
};

export const setHRBetslipSystem = data => dispatch => {
  dispatch({
    type: SET_SYSTEM,
    payload: data?.sort((a, b) => a - b)
  });
};

export const toggleHRBetSlip = val => dispatch => {
  dispatch({
    type: TOGGLE_HR_BETSLIP,
    payload: val
  });
};

export const toggleSystemModal = val => dispatch => {
  dispatch({
    type: TOGGLE_SYSTEM_MODAL,
    payload: val
  });
};

export const verifyTJKCoupon = () => async (dispatch, getState) => {
  const programType = getState().horseRacing.allHippodromes.programType;
  const isFixed = programType === PROGRAM_TYPES.FIXED;
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    dispatch({
      type: VERIFY_TJK_COUPON_REQUEST
    });

    const {
      legs,
      selectedInfos: { selectedBet, selectedHippodrome, legsData, selectedRaceNumber },
      combinedHorses,
    } = getState().horseRacing.betSlip;
    const { multiplier, couponCount, allVariation, system, fixedOddMultiplier } = getState().horseRacing.betSlip.footerData;

    let selectedLegs = [];
    legs?.forEach(l => {
      if (l) {
        selectedLegs.push(l.map(el => el.horseNo.toString()));
      }
    });
    let requestBody;
    if (isFixed) {
      requestBody = {
        propositions: combinedHorses.map(h => {
          return {
            propositionBetTypeId: h?.bet?.id,
            clientOdd: h?.horse?.propositionInfo?.odd,
            propositionId: h?.horse?.propositionInfo?.propositionId,

          };
        }),
        useNotRunning: false,
        stake: (fixedOddMultiplier || 1) * 1,
        complete: allVariation,
        couponCount: couponCount * 1,
        systemSelections: system
      };
    } else {
      requestBody = {
        cardId: selectedHippodrome.cardId,
        betTypeId: selectedBet.id,
        raceNumber: legsData[0]?.legNo,
        stake: (multiplier || 1) * 1,
        complete: allVariation,
        couponCount: couponCount * 1,
        selectable: selectedRaceNumber,
        legs: selectedLegs.map(sl => sl.join()),
        akey: selectedHippodrome.akey,
        programDate: new Date(selectedHippodrome.raceDate).getTime()
      };
    }


    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = '/mobile/tjk/coupon/verify';
        break;
      case PROGRAM_TYPES.FIXED:
        api = '/product/fixodds/coupon/verify/v3';
        break;
      default:
        api = '/mobile/tjk/coupon/verify';
        break;
    }

    const res = await axios.post(api, requestBody);
    catchTJKError(res.data);
    if (!res?.data?.body?.systemAllowed && isFixed) {
      dispatch(setHRBetslipSystem([combinedHorses?.length]));
    }


    dispatch({
      type: VERIFY_TJK_COUPON_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    const {
      combinedHorses,
    } = getState().horseRacing.betSlip;

    if (isFixed) {
      if (!e?.extras?.systemAllowed) {
        dispatch(setHRBetslipSystem([combinedHorses.length]));
      }

      if (e?.extras?.maxCouponCost) {
        dispatch(setHRBetslipMultiplier(e?.extras?.maxCouponCost));
      }
    }


    dispatch({
      type: VERIFY_TJK_COUPON_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });

    if (e.response?.data) {
      // [MODAL] Error kodlarına göre...
    }
  }
};

export const playTJKCoupon = () => async (dispatch, getState) => {
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    const isAuthenticated = getState().auth.isAuthenticated;

    if (!isAuthenticated) {
      History.push('/giris-yap');
      return;
    }

    const { balance } = getState().auth.data;
    const couponCost = getHRBetSlipCouponCost(getState);

    if (balance < couponCost) {
      return openHRInsufficientFundsFlow(dispatch, getState);
    }

    const {
      legs,
      selectedInfos: { selectedBet, selectedHippodrome, legsData, selectedRaceNumber },
      combinedHorses
    } = getState().horseRacing.betSlip;
    const { multiplier, allVariation, couponCount, system, fixedOddMultiplier } = getState().horseRacing.betSlip.footerData;

    let selectedLegs = [];
    legs?.forEach(l => {
      if (l) {
        selectedLegs.push(l.map(el => el.horseNo.toString()));
      }
    });
    const programType = getState().horseRacing.allHippodromes.programType;
    let requestBody;
    if (programType === PROGRAM_TYPES.FIXED) {
      requestBody = {
        propositions: combinedHorses.map(h => {
          return {
            propositionBetTypeId: h?.bet?.id,
            clientOdd: h?.horse?.propositionInfo?.odd,
            propositionId: h?.horse?.propositionInfo?.propositionId

          };
        }),
        useNotRunning: false,
        stake: (fixedOddMultiplier || 1) * 1,
        complete: allVariation,
        couponCount: couponCount * 1,
        systemSelections: system
      };
    } else {
      requestBody = {
        cardId: selectedHippodrome.cardId,
        betTypeId: selectedBet.id,
        raceNumber: legsData[0]?.legNo,
        stake: multiplier * 1,
        complete: allVariation,
        couponCount: couponCount,
        selectable: selectedRaceNumber,
        legs: selectedLegs.map(sl => sl.join()),
        akey: selectedHippodrome.akey,
        programDate: new Date(selectedHippodrome.raceDate).getTime()
      };
    }

    dispatch({
      type: PLAY_TJK_COUPON_REQUEST
    });

    dispatch(openModal('TJKcouponPlayLoader'));

    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = '/mobile/tjk/coupon/play';
        break;
      case PROGRAM_TYPES.FIXED:
        api = '/product/fixodds/coupon/play/v3';
        break;
      default:
        api = '/mobile/tjk/coupon/play';
        break;
    }

    const res = await axios.post(api, requestBody);

    catchTJKError(res.data);

    dispatch({
      type: PLAY_TJK_COUPON_SUCCESS,
      payload: res.data
    });

    let _obj = {
      ...res?.data?.body?.couponStatus,
      programType
    };

    if (programType === PROGRAM_TYPES.FIXED) {
      _obj.fixedOdd = res.data?.body?.fixedOddPlayResponse;
      _obj.horses = combinedHorses;
    }


    dispatch(closeModal('TJKcouponPlayLoader'));
    dispatch(updateUserBalance());
    dispatch(openModal('tjkPlayCouponSuccessModal', { result: _obj }));
    dispatch(resetHRBetSlip());
    dispatch({
      type: TOGGLE_HR_BETSLIP,
      payload: false
    });
  } catch (e) {
    dispatch(closeModal('TJKcouponPlayLoader'));

    if (isHRInsufficientBalanceError(e)) {
      openHRInsufficientFundsFlow(dispatch, getState);
    } else {
      dispatch(openModal('tjkPlayCouponFailureModal', { error: e }));
    }

    dispatch({
      type: PLAY_COUPON_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });

    if (e?.code === 1007 && e?.domain === 'tjk-mobile-bff') { //playde koşmaz at yakalanırsa betslip hata verfiy hatası da tetiklenir.
      dispatch({
        type: VERIFY_TJK_COUPON_FAILURE,
        payload: e.response?.data || (e.message ? e : errorMessage),
      });
    }

  }
};

export const setOrderedLegs = legs => async dispatch => {
  dispatch({
    type: SET_ORDERED_LEGS,
    payload: legs
  });
};

export const cancelTJKCoupon = requestBody => async dispatch => {
  if (isTjkPlayDisable()) {
    return null;
  }
  try {
    dispatch({
      type: CANCEL_TJK_COUPON_REQUEST
    });
    // cancel servisine gelirken coupon response unda dönen parentId gönderilmeli
    // {
    //   parentId: string
    // }
    const res = await axios.post('/mobile/tjk/coupon/cancel', requestBody);

    catchTJKError(res.data);

    // Geliştirme gerekli mi??
    if (res.data.body.couponStatus.success === 0) {
      dispatch(closeModal('tjkCouponCancelLoader'));
      dispatch(openModal('tjkCouponCancelFailureModal'));
    } else if (res.data.body.couponStatus.success > 0) {
      dispatch(closeModal('tjkCouponCancelLoader'));
      dispatch(openModal('tjkCouponCancelSuccessModal'));
    }
    dispatch({
      type: CANCEL_TJK_COUPON_SUCCESS,
      payload: res.data
    });
    // Devam Eden
    History.push(TJK_URL_SUFFIX.coupons.fullPage, { activeTabId: 1 });
    dispatch(resetCouponsPagination(true));
    // dispatch(getContinuedCoupons());
    dispatch(updateUserBalance());
  } catch (e) {
    dispatch(openModal('tjkCouponCancelFailureModal'));
    dispatch({
      type: CANCEL_TJK_COUPON_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setHRBetslipFromCoupons = (data, bet, isLoadedFromCouponConfig, isFromAuthors) => (dispatch, getState) => {
  if (isTjkPlayDisable()) {
    return null;
  }
  const _legs = getState().horseRacing.betSlip?.legs;
  const allHippodromes = getState().horseRacing.allHippodromes;
  const { location } = findInHippodromeByName(data.selectedInfos.selectedHippodrome.name, allHippodromes.data);
  const preparedParams = location ? location + TJK_URL_SUFFIX.program.urlSuffix : '';
  const navObj = {
    pathname: `${TJK_URL_SUFFIX.program.fullPage}${preparedParams !== '' ? ('/' + preparedParams) : ''}`,
    search: qs.stringify({
      bt: bet.betTypeId,
      rt: bet.selectableRace,
      ln: data.selectedInfos.legsData[0].legNo,
      li: '',
      dwp: true
    })
  };

  if (!isBetSlipEmpty(_legs)) {
    dispatch(openModal('tjkCouponInformationModal', {
      successCallback: () => {
        dispatch({
          type: SET_HR_BETSLIP_FROM_COUPON,
          payload: data ? data : {},
          isLoadedFromCouponConfig: isLoadedFromCouponConfig
        });
        if (bet) {
          History.push(navObj);
        }
      }
    }));
    return;
  }

  dispatch({
    type: SET_HR_BETSLIP_FROM_COUPON,
    payload: data ? data : {},
    isLoadedFromCouponConfig: isLoadedFromCouponConfig
  });

  if (bet) {
    History.push(navObj);
  }
};

export const setFromAuthorData = data => dispatch => {
  dispatch({
    type: SET_FROM_AUTHOR_DATA,
    payload: data
  });
};

export const clearFromAuthorData = () => dispatch => {
  dispatch({
    type: CLEAR_FROM_AUTHOR_DATA
  });
};

export const setBetslipToast = data => dispatch => {
  dispatch({
    type: SET_BETSLIP_TOAST,
    payload: data
  });
};

const getHRBetSlipCouponCost = getState => {
  const { couponCount } = getState().horseRacing.betSlip.footerData;
  const verify = getState().horseRacing.betSlip.verify;
  const cost = verify?.data?.body?.cost || verify?.error?.extras?.cost || 0;

  return (couponCount || 1) * cost;
};

const openHRInsufficientFundsFlow = (dispatch, getState) => {
  if (shouldRedirectToLowBalanceFastDeposit(getState)) {
    return History.push({ pathname: '/yetersiz-bakiye', state: { gameType: 'horseracing' } });
  }

  return dispatch(openModal('tjkPlayCouponFailureModal', {
    error: { domain: 'tjk-coupon-api', code: 1001 }
  }));
};

const isHRInsufficientBalanceError = error => `${error?.domain || ''}${error?.code || ''}` === 'tjk-coupon-api1001';

export const resetBetSlipToast = () => dispatch => {
  dispatch({
    type: SET_BETSLIP_TOAST,
    payload: { show: false, content: null, buttonText: null, icon: null, onHide: null, onButtonClick: null }
  });
};
